import React from 'react';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../../components/base/Dialog/Dialog';
import { Button, Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import { copyTextToClipboard } from '../../../../utils/utils';

export function InviteFormModal(props) {
  const {
    onClose = () => {}, link = 'https://www.invite.com/invite',
  } = props;

  return (
    <Dialog
      className="uspd-invite-form"
      onClose={onClose}
      open
    >
      <DialogTitle header="Ссылка - приглашение" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="uspd-invite-form-content">
        <div className="invite-action-content-info">
          <div className="invite-action-content-info-icon">
            <Icons width={24} height={24} customIcon icon="info-successfully" />
          </div>
          <div className="invite-action-content-info-text">
            <div className="invite-action-content-info-text-title">Создание приглашения на представительство</div>
            <div>Приглашение успешно создано</div>
          </div>
        </div>
        <div className="f4 mt-4">Скопируйте ссылку и отправьте доверителю</div>
        <Row className="row-cols-1 mt-3">
          <TextInputWithLabel
            inputProps={{
              value: link,
            }}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
            label="Ссылка-приглашение"
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button onClick={() => { copyTextToClipboard(link); onClose(); }}>Скопировать ссылку</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
